/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import DeviceModelRoutes from './device-model.routes';
import DeviceModelDirective from './device-model.directive';
import DeviceModelTableConfig from './device-model-table.config';

export default angular.module('tektelic.deviceModel', [])
    .config(DeviceModelRoutes)
    .directive('tkDeviceModel', DeviceModelDirective)
    .factory('deviceModelTableConfig', DeviceModelTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/device-model/index.js